export enum CLIENT_LEVEL_VIEW {
  CURRENT = 'CURRENT',
  RECOMMENDED = 'RECOMMENDED',
  MIXED = 'MIXED',
}
